/* requires:
polyfill.js
*/

const locationForm = {
  apiBaseUrl: 'cart_domain_replaced_during_build',
  currentPage: 1,
  paginationLimit: 5,

  init: () => {
    locationForm.initLocationForm();
    locationForm.zipCodeValidation();
  },

  zipCodeValidation: () => {
    // get zip code input element
    const zipCodeInput = document.querySelector('#zipcode');
    // get check location button element
    const checkLocationBtn = document.querySelector('.check-location-btn');
    // check if button exists before moving on
    if (checkLocationBtn) {
      // add event listener to zip code input
      checkLocationBtn.disabled = true;
      const locationTableWrap = document.querySelector('.location-results');
      zipCodeInput.addEventListener('change', (event) => {
        if (locationTableWrap.classList.contains('d-none') == false) {
          locationTableWrap.classList.add('d-none');
        }
        // get zip code value from input
        const zipCodeValue = event.target.value;
        // validate zip code
        const zipCodeRegex = /(^\d{5}$)/;
        if (!zipCodeRegex.test(zipCodeValue)) {
          // if zip code is invalid, show error message
          const zipCodeError = document.querySelector('.zip-code-warning');
          zipCodeError.classList.remove('d-none');
          // disable check location button
          checkLocationBtn.disabled = true;
        } else {
          // if zip code is valid, hide error message
          const zipCodeError = document.querySelector('.zip-code-warning');
          zipCodeError.classList.add('d-none');
          // enable check location button
          checkLocationBtn.disabled = false;
        }
      });
    }
  },

  // disable location form submit button if zip code is invalid

  initLocationForm: () => {
    // when form is submitted
    document.addEventListener(
      'submit',
      (event) => {
        // prevent default form submission
        event.preventDefault();
        // get form element
        const eventElement = event.target;
        // get form element closest to the submit button
        const theForm = eventElement.closest('#location-form');
        // if form exists
        if (theForm) {
          // get no address message
          const noAddress = document.querySelector('.no-locations');
          // get zip code value
          const zipCodeValue = theForm.querySelector('#zipcode').value;
          const distance = theForm.querySelector('#within').value;
          const locationQuery = `zip=${zipCodeValue}&range=${distance}&provider=PSITestCenter`;
          const url = `${locationForm.apiBaseUrl}/request/testingCenterLocatorApi/getNearbyLocations?${locationQuery}`;
          fetch(url, { credentials: 'include', mode: 'cors' })
            .then(checkFetchStatus)
            .then((res) => {
              if (res && res?.data?.length > 0) {
                if (noAddress.classList.contains('d-none') == false) {
                  noAddress.classList.add('d-none');
                }
                locationForm.initMapModal();
                locationForm.currentPage = 1;
                locationForm.renderAddressesTable(res.data, locationForm.currentPage);
                locationForm.renderPaginationButtons(res.data);
                window.location.href = '#location-results-table';
              } else {
                const locationTableWrap = document.querySelector('.location-results');
                if (locationTableWrap.classList.contains('d-none') == false) {
                  locationTableWrap.classList.add('d-none');
                }
                noAddress.classList.remove('d-none');
              }
            })
            .catch(function (err) {
              console.error(err);
            });
        }
      },
      true
    );
  },

  initMapModal: () => {
    document.addEventListener('click', (event) => {
      const eventElement = event.target;
      const mapBtn = eventElement.closest('.map-btn');
      if (mapBtn) {
        const mapModal = document.querySelector('#map-modal');
        const mapIframe = mapModal.querySelector('iframe');
        mapIframe.src = mapBtn.dataset.src;
        mapModal.classList.remove('d-none');
      }
    });
  },

  renderAddressesTable: (locationData, currentPage) => {
    // get location results wrapper
    const locationWrap = document.querySelector('.location-results');
    const locationTableWrap = document.querySelector('.location-table');
    locationWrap.classList.remove('d-none');
    // get number of addresses to display per page
    const rowsPerPage = locationForm.paginationLimit;
    let start = rowsPerPage * (currentPage - 1);
    let end = start + rowsPerPage;
    let paginatedItems = locationData.slice(start, end);
    // create table body rows for addresses
    let tableBodyRows = '';
    for (const address of paginatedItems) {
      // get address from array
      const { address1, address2, city, state, zip, distance } = address;
      const completeAddress = `${address1} ${address2} ${city}, ${state} ${zip}`;
      const mapBaseUrl = 'https://www.google.com/maps/embed/v1/place?key=AIzaSyD-akNqjQM4u0ZMXqP9Hk3BSu8fG0IZvy0&q=';
      // create table row for each address
      const tableRow = `
      <tr class="align-middle">
        <td>
          ${address1} ${address2}<br>${city}, ${state}
        </td>
        <td>${Math.round(distance * 10) / 10} miles</td>
        <td><button class="map-btn btn btn-outline-secondary" type="button" data-src=
        "${mapBaseUrl}${completeAddress}" data-bs-toggle="modal" data-bs-target="#map-modal"><span class="material-icons align-middle">place</span></button></td>
      </tr>`;
      // append addresses in the table body
      tableBodyRows += tableRow;
    }
    // add table body to table, add pagination to table
    const locationTable = `
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col">Location</th>
              <th scope="col">Distance</th>
              <th scope="col">Map</th>
            </tr>
          </thead>
          <tbody>${tableBodyRows}</tbody>
        </table>`;
    locationTableWrap.innerHTML = locationTable;
  },

  renderPaginationButtons: (locationData) => {
    if (locationData.length <= locationForm.paginationLimit) {
      const paginationNav = document.querySelector('.location-pagination-buttons');
      paginationNav.innerHTML = ''; // remove pagination nav
      return; // no pagination needed
    }

    const numberOfTablePages = Math.ceil(locationData.length / locationForm.paginationLimit);
    let paginationNumberButtons = '';

    //create pagination links
    for (let i = 1; i <= numberOfTablePages; i++) {
      paginationNumberButtons += `
      <li class="page-item">
        <button class="page-link page-numbers" data-page="${i}">${i}</button>
      </li>
      `;
    }
    // create pagination nav
    const paginationNav = `
      <nav class="location-pagination">
        <ul class="pagination pagination-sm">
          <li class="page-item">
            <button class="page-link" aria-label="Previous" data-page="page-prev">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          ${paginationNumberButtons}
          <li class="page-item">
            <button class="page-link" aria-label="Next" data-page="page-next">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>`;

    const locationPaginationWrap = document.querySelector('.location-pagination-buttons');
    locationPaginationWrap.innerHTML = paginationNav;

    // add pagination event listeners
    locationForm.addPaginationListener(locationData);
  },

  addPaginationListener: (locationData) => {
    const numPages = Math.ceil(locationData.length / locationForm.paginationLimit);
    const paginationNumbers = document.querySelectorAll('.page-numbers');
    const paginationPrev = document.querySelector('[data-page="page-prev"]');
    const paginationNext = document.querySelector('[data-page="page-next"]');
    paginationPrev.disabled = true;
    paginationPrev.classList.add('bg-btn-disabled');

    // disable prev/next buttons if on first/last page
    const initPrevNext = (currentPage) => {
      if (currentPage === 1) {
        paginationPrev.disabled = true;
        if (paginationPrev.classList.contains('bg-btn-disabled') == false) {
          paginationPrev.classList.add('bg-btn-disabled');
        }
      } else {
        if (paginationPrev.classList.contains('bg-btn-disabled')) {
          paginationPrev.classList.remove('bg-btn-disabled');
        }
        paginationPrev.disabled = false;
      }
      if (currentPage === numPages) {
        paginationNext.disabled = true;
        paginationNext.classList.add('bg-btn-disabled');
      } else {
        if (paginationNext.classList.contains('bg-btn-disabled')) {
          paginationNext.classList.remove('bg-btn-disabled');
        }
        paginationNext.disabled = false;
      }
    };

    const addActiveClass = (currentPage) => {
      // remove active class from all pagination buttons
      paginationNumbers.forEach((link) => {
        link.classList.remove('active');
      });
      // if page number is clicked set active class
      const activePage = document.querySelector(`[data-page="${currentPage}"]`);
      activePage.classList.add('active');
    };

    addActiveClass(locationForm.currentPage);

    // add event listeners to pagination buttons
    paginationNumbers.forEach((button) => {
      // get page number from button
      const pageIndex = parseInt(button.dataset.page);
      button.addEventListener('click', (event) => {
        event.preventDefault();
        locationForm.currentPage = pageIndex; // set current page to page number
        addActiveClass(locationForm.currentPage); // add active class to page number
        initPrevNext(locationForm.currentPage); // disable prev/next buttons if on first/last page
        locationForm.renderAddressesTable(locationData, locationForm.currentPage); // render table with addresses
        window.location.href = '#location-results-table'; // scroll to table
      });
    });

    paginationPrev.addEventListener('click', (event) => {
      event.preventDefault();
      // set current page to page number
      locationForm.currentPage = locationForm.currentPage - 1;
      // disable prev/next buttons if on first/last page
      initPrevNext(locationForm.currentPage);
      if (locationForm.currentPage < 1) {
        locationForm.currentPage = 1;
      }
      addActiveClass(locationForm.currentPage);
      locationForm.renderAddressesTable(locationData, locationForm.currentPage);
      window.location.href = '#location-results-table';
    });
    paginationNext.addEventListener('click', (event) => {
      event.preventDefault();
      // set current page to page number
      locationForm.currentPage = locationForm.currentPage + 1;
      initPrevNext(locationForm.currentPage);
      addActiveClass(locationForm.currentPage);
      locationForm.renderAddressesTable(locationData, locationForm.currentPage);
      window.location.href = '#location-results-table';
    });
  },
};

locationForm.init();
